<section
  class="section padd-t-96 white-100 podcast-article-banner"
  *ngIf="articleData"
>
  <div class="section-container social-link-container">
    <ul class="social_links nav flex-column">
      <li>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 11.9916C1.99926 12.9878 2.39394 13.9436 3.09728 14.6488C3.80063 15.354 4.75508 15.751 5.75087 15.7524C6.30421 15.7526 6.85069 15.6299 7.35089 15.3932C7.85109 15.1565 8.29256 14.8116 8.64345 14.3836L14.5958 17.361C14.525 17.6512 14.4894 17.9489 14.4899 18.2476C14.4914 19.2423 14.887 20.1959 15.5901 20.8993C16.2932 21.6027 17.2464 21.9985 18.2408 22C19.2351 21.9985 20.1883 21.6027 20.8914 20.8993C21.5945 20.1959 21.9902 19.2423 21.9916 18.2476C21.9887 17.2538 21.5924 16.3016 20.8894 15.5994C20.1865 14.8972 19.2341 14.5022 18.2408 14.5007C17.6894 14.5019 17.1451 14.6247 16.6466 14.8603C16.1481 15.0959 15.7076 15.4386 15.3566 15.864L9.407 12.8893C9.47567 12.5951 9.50842 12.2937 9.50453 11.9916C9.50503 11.6929 9.46947 11.3953 9.39864 11.1051L15.3566 8.13883C15.7081 8.56592 16.1498 8.90988 16.6499 9.14606C17.15 9.38223 17.6961 9.50477 18.2491 9.50488C19.2435 9.5034 20.1967 9.10759 20.8998 8.40419C21.6029 7.70079 21.9985 6.7472 22 5.75244C21.9985 4.75768 21.6029 3.80409 20.8998 3.10069C20.1967 2.39729 19.2435 2.00147 18.2491 2C17.2548 2.00147 16.3016 2.39729 15.5985 3.10069C14.8954 3.80409 14.4997 4.75768 14.4983 5.75244C14.4978 6.05206 14.5333 6.35064 14.6042 6.64176L8.65459 9.61918C8.30342 9.19057 7.86157 8.84523 7.3609 8.60804C6.86023 8.37086 6.3132 8.24774 5.75923 8.24756C4.76489 8.24682 3.81081 8.64051 3.10614 9.34234C2.40147 10.0442 2.00369 10.9969 2 11.9916Z"
            fill="#969CA4"
          />
        </svg>
      </li>
      <li>
        <a (click)="social('facebook')">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.3335 8.00065C1.3335 11.3007 3.7335 14.034 6.90016 14.6007L6.93959 14.5684C6.93765 14.568 6.9357 14.5677 6.93376 14.5673V9.86733H5.26709V8.00067H6.93376V6.534C6.93376 4.86733 8.00042 3.934 9.53376 3.934C10.0004 3.934 10.5338 4.00067 11.0004 4.06733V5.76733H10.1338C9.33376 5.76733 9.13376 6.16733 9.13376 6.70067V8.00067H10.9004L10.6004 9.86733H9.13376V14.5673C9.11339 14.571 9.09302 14.5746 9.07265 14.5781L9.10016 14.6007C12.2668 14.034 14.6668 11.3007 14.6668 8.00065C14.6668 4.33398 11.6668 1.33398 8.00016 1.33398C4.3335 1.33398 1.3335 4.33398 1.3335 8.00065Z"
              fill="white"
            />
          </svg>
        </a>
      </li>
      <li>
        <a (click)="social('twitter')">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.52683 13.9268C10.5588 13.9268 13.3102 9.59468 13.3102 5.83823C13.3102 5.71503 13.3075 5.59248 13.3022 5.4706C13.8412 5.06418 14.3033 4.56581 14.6668 3.99876C14.1699 4.2283 13.64 4.37938 13.0962 4.44654C13.6729 4.08215 14.0987 3.52411 14.2962 2.87401C13.7624 3.20382 13.1743 3.43747 12.5588 3.56423C12.3082 3.28264 12.0004 3.05701 11.6557 2.90219C11.311 2.74737 10.9371 2.66688 10.5588 2.66602C9.81722 2.68339 9.11285 2.99246 8.60038 3.52537C8.08791 4.05828 7.80922 4.77147 7.8255 5.50836C7.82495 5.72645 7.84865 5.94393 7.89616 6.15685C6.79732 6.09308 5.72522 5.79476 4.75288 5.28221C3.78053 4.76966 2.93078 4.05492 2.2615 3.18666C2.01681 3.62361 1.88853 4.11542 1.88883 4.61545C1.88556 5.0782 1.99468 5.53491 2.20695 5.94681C2.41923 6.35872 2.72837 6.71366 3.10816 6.98153C2.67199 6.96731 2.24627 6.84528 1.8695 6.62648C1.8695 6.63841 1.8695 6.65033 1.8695 6.66292C1.85939 7.30658 2.07166 7.93424 2.47091 8.44123C2.87016 8.94821 3.43227 9.30389 4.0635 9.44896C3.66159 9.56321 3.23796 9.58002 2.82816 9.49797C2.99019 10.0528 3.32456 10.5424 3.78349 10.8971C4.24243 11.2517 4.80244 11.4531 5.3835 11.4726C4.82451 11.9322 4.17702 12.2736 3.48064 12.476C2.78426 12.6784 2.05365 12.7375 1.3335 12.6497C2.57196 13.481 4.0322 13.9258 5.52683 13.9268Z"
              fill="white"
            />
          </svg>
        </a>
      </li>
      <li>
        <a (click)="social('linkedin')">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.3765 5.43892C10.8514 5.42232 10.3321 5.5516 9.87699 5.8122C9.42184 6.0728 9.04889 6.4544 8.80007 6.91408V6.94292H8.78124C8.78848 6.93396 8.79478 6.9243 8.80007 6.91408V5.64854H5.94287C5.97973 6.48626 5.94287 14.5853 5.94287 14.5853H8.80007V9.59791C8.78886 9.35299 8.82071 9.10801 8.89418 8.87396C8.99389 8.56302 9.1888 8.29076 9.45173 8.09518C9.71465 7.8996 10.0325 7.79046 10.3608 7.78298C11.3961 7.78298 11.8086 8.60355 11.8086 9.80441V14.586H14.6666V9.46153C14.6674 6.71615 13.2564 5.43892 11.3765 5.43892Z"
              fill="white"
            />
            <path
              d="M4.36075 5.64844H1.50195V14.5848H4.36075V5.64844Z"
              fill="white"
            />
            <path
              d="M2.94977 1.33681C2.7393 1.32402 2.52845 1.35479 2.33057 1.42717C2.1327 1.49955 1.9521 1.61197 1.80022 1.7573C1.64835 1.90262 1.5285 2.0777 1.44826 2.27144C1.36803 2.46518 1.32915 2.67337 1.33411 2.88281C1.3282 3.08928 1.36518 3.29475 1.44275 3.4864C1.52032 3.67804 1.63681 3.85174 1.78495 3.99666C1.9331 4.14158 2.10971 4.25461 2.30378 4.3287C2.49785 4.40278 2.70521 4.43633 2.91291 4.42726H2.93095C3.14147 4.44037 3.35244 4.40989 3.55049 4.33775C3.74854 4.26562 3.92935 4.1534 4.08146 4.0082C4.23357 3.863 4.35367 3.688 4.43414 3.49428C4.51462 3.30055 4.55372 3.09233 4.54896 2.88281C4.55457 2.6746 4.51671 2.4675 4.43776 2.27455C4.35881 2.08161 4.24048 1.907 4.09023 1.76175C3.93998 1.6165 3.76108 1.50375 3.56479 1.43062C3.36851 1.35748 3.1591 1.32554 2.94977 1.33681Z"
              fill="white"
            />
          </svg>
        </a>
      </li>
      <li>
        <a (click)="copyUrl()">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.6668 8.60065V11.4007C10.6668 13.734 9.7335 14.6673 7.40016 14.6673H4.60016C2.26683 14.6673 1.3335 13.734 1.3335 11.4007V8.60065C1.3335 6.26732 2.26683 5.33398 4.60016 5.33398H7.40016C9.7335 5.33398 10.6668 6.26732 10.6668 8.60065Z"
              fill="white"
            />
            <path
              d="M11.3998 1.33398H8.59984C6.67914 1.33398 5.71152 1.97092 5.42907 3.49325C5.32748 4.04082 5.79484 4.50065 6.35175 4.50065H7.39984C10.1998 4.50065 11.4998 5.80065 11.4998 8.60065V9.64875C11.4998 10.2057 11.9597 10.673 12.5072 10.5714C14.0296 10.289 14.6665 9.32135 14.6665 7.40065V4.60065C14.6665 2.26732 13.7332 1.33398 11.3998 1.33398Z"
              fill="white"
            />
          </svg>
        </a>
      </li>
    </ul>
  </div>
  <div class="section-container">
    <div class="inner-wrapper">
      <h2 class="section-heading mar-b-24">
        {{ articleData?.header }}
      </h2>
      <p>
        <time>{{ articleData?.datestamp | date: 'longDate' }} · </time>
        <span class="status text-light">{{ articleData?.readtime }}</span>
      </p>
      <figure class="vdo_figure m-0"></figure>
      <div class="wys" [innerHtml]="articleData?.paragraph | toHtml"></div>
    </div>
  </div>
</section>
